import i18n from '@/i18n';

const PROJECT_STATUS_KEYS: Record<string, string> = {
  'pre-queued': 'projectStatus.preQueued',
  queued: 'projectStatus.queued',
  processing: 'projectStatus.processing',
  transcribing: 'projectStatus.transcribing',
  segmenting: 'projectStatus.segmenting',
  trimming: 'projectStatus.trimming',
  curating: 'projectStatus.curating',
  success: 'projectStatus.success',
  failure: 'projectStatus.failure',
  expired: 'projectStatus.expired',
};

export type ProjectStatus = 'pre-queued' | 'queued' | 'processing' | 'transcribing' | 'segmenting' | 'trimming' | 'curating' | 'success' | 'failure' | 'expired';

export function getProjectStatusLabel(status?: string | null): string {
  if (!status) return '';
  const key = PROJECT_STATUS_KEYS[status];
  return key ? i18n.t(key) : status;
}


